import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

interface PAYLOAD {
  type: string;
  source: string;
  referenceId: string;
  otp: string;
}

export default function useVerifyOtp() {
  const { state } = useProvider();
  const args = state;

  return useMutation<any, ApiError, PAYLOAD, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/public/common/otp/verify',
        payload,
      });

      return data;
    },
  });
}
